export default "__VITE_ASSET__Beb5DznC__"